import { Car } from '../types/carTypes';
import { Dealer } from '../types/dealerTypes';
import { PageWidgetConfig, WidgetConfig } from '../types/widgetTypes';
import { BackendService } from './BackendService';

interface GetButtonGroupsPreviewResult {
  CSS: string; // html style tag
  buttonGroups: {
    [index: string /* vin */]: string | undefined /* html div tag */;
  };
}

export default class WidgetService {
  static getConfig(dealerId: string) {
    return BackendService.get<WidgetConfig>(`/widgets/config/${dealerId}`);
  }

  static getButtonGroupsPreview(body: {
    car: Car;
    config: PageWidgetConfig;
    dealer: Dealer;
  }) {
    return BackendService.post<GetButtonGroupsPreviewResult>(
      `/widgets/buttonGroups/preview`,
      body,
    );
  }

  static updateConfig(dealerId: string, config: Partial<WidgetConfig>) {
    return BackendService.put(`/widgets/config/${dealerId}`, config);
  }
}
